export const buildAddressLabel = (values: (string | undefined)[]) => {
  const addressString = values
    .map((addressValue) => addressValue && addressValue.trim())
    .filter((addressValue) => addressValue)
    .join(', ');

  return addressString;
};
